/**
 * Base de données des marques et modèles par type de véhicule
 */

export interface BrandModels {
  brand: string;
  models: string[];
}

export interface VehicleTypeBrands {
  type: string;
  brands: BrandModels[];
}

// Marques et modèles pour VL (Véhicules Légers)
const vlBrands: BrandModels[] = [
  { brand: "Renault", models: ["Clio", "Megane", "Captur", "Kadjar", "Arkana", "Scenic", "Talisman", "Austral", "Espace"] },
  { brand: "Peugeot", models: ["208", "308", "408", "508", "2008", "3008", "5008", "Rifter", "Partner"] },
  { brand: "Citroën", models: ["C3", "C4", "C5 X", "Berlingo", "C3 Aircross", "C4 Picasso", "SpaceTourer"] },
  { brand: "Volkswagen", models: ["Polo", "Golf", "Passat", "Tiguan", "T-Roc", "Touran", "ID.3", "ID.4"] },
  { brand: "Toyota", models: ["Yaris", "Corolla", "Camry", "RAV4", "C-HR", "Proace", "Yaris Cross"] },
  { brand: "Ford", models: ["Fiesta", "Focus", "Mondeo", "Puma", "Kuga", "Mustang Mach-E"] },
  { brand: "Opel", models: ["Corsa", "Astra", "Insignia", "Mokka", "Crossland", "Grandland"] },
  { brand: "Fiat", models: ["500", "Panda", "Tipo", "500X", "Doblo"] },
  { brand: "Dacia", models: ["Sandero", "Duster", "Logan", "Spring", "Jogger"] },
  { brand: "Hyundai", models: ["i10", "i20", "i30", "Tucson", "Kona", "Ioniq", "Santa Fe"] },
  { brand: "Kia", models: ["Picanto", "Rio", "Ceed", "Sportage", "Niro", "EV6", "Sorento"] },
  { brand: "Nissan", models: ["Micra", "Juke", "Qashqai", "X-Trail", "Leaf", "Ariya"] },
  { brand: "BMW", models: ["Série 1", "Série 3", "Série 5", "X1", "X3", "X5", "iX"] },
  { brand: "Mercedes", models: ["Classe A", "Classe C", "Classe E", "GLA", "GLC", "GLE", "EQA", "EQC"] },
  { brand: "Audi", models: ["A1", "A3", "A4", "A6", "Q3", "Q5", "e-tron"] },
];

// Marques et modèles pour VUL (Véhicules Utilitaires Légers)
const vulBrands: BrandModels[] = [
  { brand: "Renault", models: ["Kangoo", "Trafic", "Master", "Express", "Kangoo E-Tech", "Master E-Tech"] },
  { brand: "Peugeot", models: ["Partner", "Expert", "Boxer", "e-Partner", "e-Expert", "e-Boxer"] },
  { brand: "Citroën", models: ["Berlingo", "Jumpy", "Jumper", "ë-Berlingo", "ë-Jumpy", "ë-Jumper"] },
  { brand: "Fiat", models: ["Doblo", "Scudo", "Ducato", "E-Doblo", "E-Scudo", "E-Ducato"] },
  { brand: "Mercedes", models: ["Citan", "Vito", "Sprinter", "eCitan", "eVito", "eSprinter"] },
  { brand: "Volkswagen", models: ["Caddy", "Transporter T6.1", "Crafter", "ID. Buzz Cargo"] },
  { brand: "Ford", models: ["Transit Connect", "Transit Custom", "Transit", "E-Transit"] },
  { brand: "Opel", models: ["Combo", "Vivaro", "Movano", "Combo-e", "Vivaro-e", "Movano-e"] },
  { brand: "Iveco", models: ["Daily", "eDaily"] },
  { brand: "Nissan", models: ["Townstar", "Primastar", "Interstar", "e-NV200"] },
  { brand: "Toyota", models: ["Proace City", "Proace", "Proace Max"] },
  { brand: "MAN", models: ["TGE"] },
];

// Marques et modèles pour PL (Poids Lourds) - Porteurs
const plBrands: BrandModels[] = [
  { brand: "Renault Trucks", models: ["D 12t", "D 16t", "D 18t", "D Wide 19t", "D Wide 26t", "C", "K", "D Z.E.", "D Wide Z.E."] },
  { brand: "Mercedes", models: ["Atego 12t", "Atego 16t", "Atego 18t", "Actros 18t", "Actros 26t", "Arocs", "eActros", "eEconic"] },
  { brand: "Volvo Trucks", models: ["FL", "FE", "FM", "FMX", "FH", "FH16", "FL Electric", "FE Electric", "FM Electric"] },
  { brand: "DAF", models: ["LF 12t", "LF 16t", "LF 18t", "CF 18t", "CF 26t", "XF", "XG", "XG+", "LF Electric", "CF Electric"] },
  { brand: "Scania", models: ["L-series", "P-series 18t", "P-series 26t", "G-series", "R-series", "S-series", "BEV"] },
  { brand: "MAN", models: ["TGL 12t", "TGL 16t", "TGM 18t", "TGM 26t", "TGS", "TGX", "eTGM", "eTGS"] },
  { brand: "Iveco", models: ["Eurocargo 12t", "Eurocargo 16t", "Eurocargo 18t", "S-Way", "X-Way", "T-Way", "Nikola Tre"] },
];

// Marques et modèles pour SPL (Super Poids Lourds) - Tracteurs
const splBrands: BrandModels[] = [
  { brand: "Renault Trucks", models: ["T", "T High", "T X-Road", "C", "K", "E-Tech T"] },
  { brand: "Mercedes", models: ["Actros", "Actros L", "Arocs", "eActros 600", "GenH2"] },
  { brand: "Volvo Trucks", models: ["FH", "FH Aero", "FH16", "FM", "FMX", "FH Electric"] },
  { brand: "DAF", models: ["XF", "XG", "XG+", "XD", "XF Electric"] },
  { brand: "Scania", models: ["R-series", "S-series", "G-series", "BEV R-series", "BEV S-series"] },
  { brand: "MAN", models: ["TGX", "TGX EfficientLine", "eTGX"] },
  { brand: "Iveco", models: ["S-Way", "S-eWay", "Nikola Tre FCEV"] },
];

// Marques et modèles pour Semi-remorques
const semiRemorqueBrands: BrandModels[] = [
  { brand: "Krone", models: ["Profi Liner", "Cool Liner", "Mega Liner", "Dry Liner", "Box Liner", "Coil Liner"] },
  { brand: "Schmitz Cargobull", models: ["S.CS", "S.KO Cool", "S.KI", "S.CF", "S.PR", "S.BO"] },
  { brand: "Lamberet", models: ["SR2", "SR2 Green Liner", "SR2 HD"] },
  { brand: "Chereau", models: ["Inogam", "Reefer", "CG Range"] },
  { brand: "Fruehauf", models: ["VAN XL", "FV", "Fourgon", "Benne"] },
  { brand: "Lecitrailer", models: ["XL", "Frigo", "Benne", "Citerne"] },
  { brand: "Wielton", models: ["NS 3", "NW 3", "PRS 3"] },
  { brand: "Kogel", models: ["Cargo", "Mega", "Cool", "Light Plus"] },
  { brand: "Benalu", models: ["BulkLiner", "Optiliner", "Liberté", "SilverStar"] },
  { brand: "Schwarzmüller", models: ["Fourgon", "Bâché", "Benne", "Plateau"] },
];

// Marques et modèles pour Remorques
const remorqueBrands: BrandModels[] = [
  { brand: "Fruehauf", models: ["Fourgon", "Bâché", "Plateau", "Benne"] },
  { brand: "Krone", models: ["AZ", "ZZ", "Profi Box"] },
  { brand: "Schmitz Cargobull", models: ["A.CS", "A.KO", "A.CF"] },
  { brand: "Schwarzmüller", models: ["Remorque fourgon", "Remorque bâchée"] },
  { brand: "Fliegl", models: ["DTS", "TDS", "DHKS"] },
];

// Marques pour Camions Benne
const benneBrands: BrandModels[] = [
  { brand: "Renault Trucks", models: ["K 8x4", "K 6x4", "C 8x4", "C 6x4"] },
  { brand: "Mercedes", models: ["Arocs 8x4", "Arocs 6x4", "Actros 8x4"] },
  { brand: "Volvo Trucks", models: ["FMX 8x4", "FMX 6x4", "FH 8x4"] },
  { brand: "Scania", models: ["G-series 8x4", "P-series 8x4", "R-series 8x4"] },
  { brand: "DAF", models: ["CF 8x4", "XF 8x4"] },
  { brand: "MAN", models: ["TGS 8x4", "TGS 6x4", "TGX 8x4"] },
  { brand: "Iveco", models: ["T-Way 8x4", "T-Way 6x4", "X-Way 8x4"] },
];

// Marques pour Camions Citerne
const citerneBrands: BrandModels[] = [
  { brand: "Renault Trucks", models: ["C Citerne", "D Wide Citerne"] },
  { brand: "Mercedes", models: ["Actros Citerne", "Arocs Citerne"] },
  { brand: "Volvo Trucks", models: ["FM Citerne", "FMX Citerne"] },
  { brand: "DAF", models: ["CF Citerne", "XF Citerne"] },
  { brand: "Scania", models: ["P-series Citerne", "G-series Citerne"] },
  { brand: "MAN", models: ["TGS Citerne", "TGM Citerne"] },
];

// Marques pour Bus/Autocar
const busBrands: BrandModels[] = [
  { brand: "Mercedes", models: ["Citaro", "Citaro NGT", "eCitaro", "Sprinter City", "Intouro", "Tourismo"] },
  { brand: "Iveco Bus", models: ["Urbanway", "Crossway", "Magelys", "Daily Minibus", "E-Way"] },
  { brand: "MAN", models: ["Lion's City", "Lion's Intercity", "Lion's Coach", "Lion's City E"] },
  { brand: "Volvo Buses", models: ["7900", "7900 Electric", "8900", "9700", "9900"] },
  { brand: "Scania", models: ["Citywide", "Interlink", "Touring"] },
  { brand: "Renault Trucks", models: ["Master Bus", "Master Minibus"] },
  { brand: "Setra", models: ["S 415 LE", "S 416 LE", "S 531 DT", "S 515 HD", "S 516 HD"] },
  { brand: "Irizar", models: ["ie bus", "i6", "i6S", "i8"] },
  { brand: "Otokar", models: ["Vectio", "Territo", "Sultan"] },
];

// Marques pour Frigorifiques (carrosseries)
const frigoBrands: BrandModels[] = [
  { brand: "Lamberet", models: ["SR2", "SR2 Green Liner", "SR2 HD", "Frigoline"] },
  { brand: "Chereau", models: ["Inogam", "Reefer", "CG Range"] },
  { brand: "Krone", models: ["Cool Liner", "Cool Liner Duoplex"] },
  { brand: "Schmitz Cargobull", models: ["S.KO Cool", "S.KO Express"] },
  { brand: "Carrier Transicold", models: ["Supra", "Vector", "Pulsor"] },
  { brand: "Thermo King", models: ["SLXi", "SLXe", "Advancer"] },
];

// Marques pour Porte-conteneur
const porteConteneurBrands: BrandModels[] = [
  { brand: "Fruehauf", models: ["PC 20'", "PC 40'", "PC 45'", "PC Multi"] },
  { brand: "Krone", models: ["Box Liner", "Container Chassis"] },
  { brand: "Schmitz Cargobull", models: ["S.CF", "S.CF 45"] },
  { brand: "Wielton", models: ["PC 40", "PC 45"] },
  { brand: "D-TEC", models: ["Flexitrailer", "Combitrailer"] },
];

// Export de toutes les données
export const vehicleTypeBrandsData: Record<string, BrandModels[]> = {
  // New enum values
  vul: vulBrands,
  pl_fourgon: plBrands,
  pl_citerne: citerneBrands,
  pl_plateau: plBrands,
  tracteur_routier: splBrands,
  semi_fourgon: semiRemorqueBrands,
  semi_citerne: semiRemorqueBrands,
  semi_plateau: semiRemorqueBrands,
  remorque_fourgon: remorqueBrands,
  remorque_citerne: remorqueBrands,
  remorque_plateau: remorqueBrands,
  vl_autocar: [...vlBrands, ...busBrands],
  // Legacy mappings for backward compatibility
  vl: vlBrands,
  fourgon: vulBrands,
  pl: plBrands,
  spl: splBrands,
  bus: busBrands,
  autocar: busBrands,
  remorque: remorqueBrands,
  semi_remorque: semiRemorqueBrands,
  camion_benne: benneBrands,
  camion_citerne: citerneBrands,
  porte_conteneur: porteConteneurBrands,
  frigorifique: frigoBrands,
};

// Fonction pour obtenir les marques selon le type de véhicule
export const getBrandsByVehicleType = (vehicleType: string): string[] => {
  const brands = vehicleTypeBrandsData[vehicleType];
  if (!brands) {
    // Retourner toutes les marques PL par défaut
    return plBrands.map(b => b.brand);
  }
  return brands.map(b => b.brand);
};

// Fonction pour obtenir les modèles selon le type et la marque
export const getModelsByBrand = (vehicleType: string, brand: string): string[] => {
  const brands = vehicleTypeBrandsData[vehicleType];
  if (!brands) return [];
  
  const brandData = brands.find(b => b.brand === brand);
  return brandData ? brandData.models : [];
};

// Fonction pour obtenir toutes les marques (pour fallback)
export const getAllBrands = (): string[] => {
  const allBrands = new Set<string>();
  Object.values(vehicleTypeBrandsData).forEach(brands => {
    brands.forEach(b => allBrands.add(b.brand));
  });
  return Array.from(allBrands).sort();
};

export default vehicleTypeBrandsData;









